import { createApp } from 'vue'
import store from "./stores";
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import { ElMessageBox } from 'element-plus'
// import GDTAdSDK from 'ylh-pc-ad-sdk';
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'element-plus/dist/index.css'
import './assets/fontAwesome/font-awesome.css'
import './assets/main.css'
import "quill/dist/quill.core.css";
import zhCn from "element-plus/es/locale/lang/zh-cn"
// import VueMathjax from 'vue-mathjax-next'; 
import vueEsign from 'vue-esign'
const mathjax = () => {
  window.MathJax = {
    tex: {
      inlineMath: [['$', '$'], ['\\(', '\\)']],
    },
  };


  // script.src = 'https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-chtml.js' // cdn引入比较慢
  // script.src = '/src/assets/TeX-AMS_HTML.js';
}

// mathjax()
// GDTAdSDK.init({ appId: '1219408016' })

const app = createApp(App)

// 防止按钮多次提交
app.directive('preventReClick', (el, binding) => {
  function preventReClickFun(elValue, bindingValue) {
    if (!elValue.disabled) {
      elValue.disabled = true
      setTimeout(() => {
        elValue.disabled = false
      }, bindingValue.value || 2000)
    }
  }
  el.addEventListener('click', () => preventReClickFun(el, binding))
  binding.dir.unmounted = function () {
    el.removeEventListener('click', () => preventReClickFun(el, binding))
  }
})

if (import.meta.env.VITE_NODE_ENV !== 'development') {

  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Model/i.test(navigator.userAgent)) {
    if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
      window.location.href = 'https://apps.apple.com/cn/app/%E6%88%90%E5%AD%A6%E8%AF%BE%E5%A0%82/id1591136429'
    } else {
      window.location.href = 'https://download.cx-online.net/#/?appName=%E6%88%90%E5%AD%A6%E8%AF%BE%E5%A0%82'
    }
  }

  function isChromeBrowser() {
    return /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
  }


  function getBrowserCoreVersion() {
    const userAgent = navigator.userAgent;
    const coreVersion = /Edge\/([0-9.]+)/.exec(userAgent) ||
      /Chrome\/([0-9.]+)/.exec(userAgent) ||
      /Version\/([0-9.]+).*Safari/.exec(userAgent) ||
      /Firefox\/([0-9.]+)/.exec(userAgent);
    return coreVersion ? coreVersion[1] : 'Unknown';
  }


  if (isChromeBrowser()) {
    const VersionText = getBrowserCoreVersion()
    const version = VersionText.split('.')[0]
    if (Number(version) <= 86) {
      ElMessageBox.alert('浏览器内核版本过低，请下载新版浏览器', '提示', {
        confirmButtonText: '确定',
        showClose: false,
        callback: (action) => {
          window.location.href = 'https://browser.360.cn/'
        },
      })
    }
  }


}




app.use(store)
  .use(router)
  .use(vueEsign)
  .use(ElementPlus, { locale: zhCn })
// .use(VueMathjax)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.mount('#app')




